import { type ReactNode, useRef } from 'react';

import { useSyncScroll } from '@/hooks/useSyncScroll';
import type { Details } from '@/stores/alignmentStore';

import { StyledListCard } from '../CourseAlignmentStyles';

interface ListCardProps {
	children: ReactNode;
	details: Details;
}

const ListCard = ({ children, details }: ListCardProps) => {
	const ref = useRef<HTMLDivElement>(null);

	// ListCard is always "open" — its accordion children determine what's visible
	useSyncScroll(ref, details.syncScroll, true);

	return <StyledListCard ref={ref}>{children}</StyledListCard>;
};

export default ListCard;
